import * as React from "react";
import PropTypes from "prop-types";
import Table from "@material-ui/core/Table/Table";
import TableHead from "@material-ui/core/TableHead/TableHead";
import TableRow from "@material-ui/core/TableRow/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody/TableBody";
import withStyles from "@material-ui/core/styles/withStyles";
import CurrencyNumber from "../UI/CurrencyNumber";
import PercentageNumber from "../UI/PercentageNumber";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  cyPortfolioTable: {
    width: "60%",
    [`@media only screen and ${theme.breakpoints.downNoMedia("md")}`]: {
      width: "80%",
      margin: "0 auto",
    },
    "@media print": {
      width: "100%",
    },
  },
  summaryRow: {
    background: theme.palette.grey[200],
  },
  tableCell: {
    padding: 2,
    fontSize: 12,
    "&.header": {
      maxWidth: 80,
      fontSize: 13,
      wordWrap: "break-word",
      fontWeight: 500,
      color: theme.palette.primary.main,
      "&.extra": {
        maxWidth: 150,
      },
    },
    "&.summary-cell": {
      fontWeight: 500,
      padding: "0 2px",
      borderBottom: "none",
      height: 24,
      lineHeight: 2,
    },
    "&.wrap-cell": {
      maxWidth: 120,
      wordWrap: "break-word",
      "&.highlighted": {
        fontWeight: 500,
        maxWidth: 120,
      },
      "&.head": {
        maxWidth: 140,
      },
    },
  },
});

const CyPortfolioOverview = (props) => {
  const { classes, clients, advisorConfig } = props;
  return (
    <React.Fragment>
      <Table className={classes.cyPortfolioTable}>
        <TableHead>
          <TableRow>
            <TableCell className={`${classes.tableCell} header extra`}>
              Data and Assumptions
            </TableCell>
            <TableCell align="right" className={`${classes.tableCell} header`}>
              {clients[0].profile.firstName + " " + clients[0].profile.lastName}
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} header`}
              >
                {clients[1].profile.firstName +
                  " " +
                  clients[1].profile.lastName}
              </TableCell>
            )}
            <TableCell align="right" className={`${classes.tableCell} header`}>
              Household (or Defaults)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/*<TableRow>*/}
          {/*  <TableCell className={`${classes.tableCell} wrap-cell head`}>Current Age</TableCell>*/}
          {/*  <TableCell align="right" className={`${classes.tableCell} wrap-cell`}>{clients[0].profile.currentAge}</TableCell>*/}
          {/*  {clients.length > 1 && <TableCell align="right"  className={`${classes.tableCell} wrap-cell`}>{clients[1].profile.currentAge}</TableCell>}*/}
          {/*  <TableCell align="right" className={`${classes.tableCell} wrap-cell`}>--</TableCell>*/}
          {/*</TableRow>*/}
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Client DOB
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              {clients[0].profile.dob}
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                {clients[1].profile.dob}
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Retirement Age
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              {clients[0].profile.retirementAge}
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                {clients[1].profile.retirementAge}
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Current Annual Income
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber value={clients[0].profile.currentIncome} />
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                <CurrencyNumber value={clients[1].profile.currentIncome} />
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Annual Income Increase
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <PercentageNumber
                value={clients[0].profile.annualIncomeIncrease}
              />
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                <PercentageNumber
                  value={clients[1].profile.annualIncomeIncrease}
                />
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Current Qualified Plan Assets
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber
                value={clients[0].profile.currentQualifiedPlans}
              />
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                <CurrencyNumber
                  value={clients[1].profile.currentQualifiedPlans}
                />
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Current Other Household Investments/Savings
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber
                value={clients[0].profile.currentNonQualifiedSavings}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Annual Qualified Plan Contributions (Employee + Employer)
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber value={clients[0].profile.annualQualifiedPlans} />
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                <CurrencyNumber
                  value={clients[1].profile.annualQualifiedPlans}
                />
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Annual Other Household Investments/Savings
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber
                value={clients[0].profile.annualNonQualifiedSavings}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Expected Monthly Social Security Income
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber value={clients[0].profile.monthlySSI} />
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                <CurrencyNumber value={clients[1].profile.monthlySSI} />
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Expected Monthly Pension Income
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber value={clients[0].profile.monthlyPension} />
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                <CurrencyNumber value={clients[1].profile.monthlyPension} />
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Expected Other Annual Income in Retirement
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber value={clients[0].profile.otherAnnualIncome} />
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                <CurrencyNumber value={clients[1].profile.otherAnnualIncome} />
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Number of Years for Expected Other Annual Income
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              {clients[0].profile.otherAnnualIncomeYears}
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                {clients[1].profile.otherAnnualIncomeYears}
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Annual Expenses Pre-Retirement
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber
                value={clients[0].profile["combinedAnnualExpenseBR"]}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Annual Expenses in Retirement
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber
                value={clients[0].profile["combinedAnnualExpenseIR"]}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Full Retirement Age (FRA) for Social Security
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              {advisorConfig["fullRetirementAge"]}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Age at Death
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              {advisorConfig["ageOfDeath"]}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Inflation Rate
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <PercentageNumber value={advisorConfig["inflationRate"]} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Effective Tax Rate (Fed + State) before Retirement
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <PercentageNumber value={advisorConfig["taxRateBR"]} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Effective Tax Rate (Fed + State) in Retirement
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <PercentageNumber value={advisorConfig["taxRateIR"]} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Effective Tax Rate (Fed + State) for Non-Qualified Asset Gains
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <PercentageNumber
                value={advisorConfig["taxRateNonQualifiedAssetGains"]}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Social Security Wage Base
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber value={advisorConfig["ssiBase"]} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell className={`${classes.tableCell} wrap-cell head`}>
              Social Security Max Benefit at FRA
            </TableCell>
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              --
            </TableCell>
            {clients.length > 1 && (
              <TableCell
                align="right"
                className={`${classes.tableCell} wrap-cell`}
              >
                --
              </TableCell>
            )}
            <TableCell
              align="right"
              className={`${classes.tableCell} wrap-cell`}
            >
              <CurrencyNumber value={advisorConfig["ssiMaxBenefitAtFRA"]} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br />
      <Typography className={"disclosure"} variant={"caption"} paragraph>
        Note: This data was collected from client to calculate Require Rate of
        Return.
      </Typography>
    </React.Fragment>
  );
};

CyPortfolioOverview.propTypes = {
  classes: PropTypes.object.isRequired,
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      profile: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
        currentAge: PropTypes.number.isRequired,
        retirementAge: PropTypes.number.isRequired,
        currentIncome: PropTypes.number.isRequired,
        annualIncomeIncrease: PropTypes.number.isRequired,
        currentQualifiedPlans: PropTypes.number.isRequired,
        currentNonQualifiedSavings: PropTypes.number.isRequired,
        annualQualifiedPlans: PropTypes.number.isRequired,
        annualNonQualifiedSavings: PropTypes.number.isRequired,
        monthlySSI: PropTypes.number.isRequired,
        monthlyPension: PropTypes.number.isRequired,
        otherAnnualIncome: PropTypes.number.isRequired,
        otherAnnualIncomeYears: PropTypes.number.isRequired,
        combinedAnnualExpenseBR: PropTypes.number.isRequired,
        combinedAnnualExpenseIR: PropTypes.number.isRequired,
      }),
    })
  ).isRequired,
  advisorConfig: PropTypes.shape({
    fullRetirementAge: PropTypes.number.isRequired,
    ageOfDeath: PropTypes.number.isRequired,
    inflationRate: PropTypes.number.isRequired,
    taxRateBR: PropTypes.number.isRequired,
    taxRateIR: PropTypes.number.isRequired,
    taxRateNonQualifiedAssetGains: PropTypes.number.isRequired,
    ssiBase: PropTypes.number.isRequired,
    ssiMaxBenefitAtFRA: PropTypes.number.isRequired,
  }).isRequired,
};

export default withStyles(styles)(CyPortfolioOverview);



// WEBPACK FOOTER //
// ./src/components/Charts/CyPortfolioOverview.jsx